import CoreApiService from "../../system/api/coreApiService"
import NewsChatRequest from '../../libs/core-api-requests/dirs/newsChatRequst';
import { INewsChatDTO, INewsChatViewDTO, INewsMakerItemCreateDTO, INewsMakerItemEditDTO, INewsMakerDTO, INewsMakerViewDTO } from '../../libs/coreapi-dto/service/newsChat';

export class NewsChatDataProvider {
    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        this._coreApiService = coreApiService
    }
    getDataRequest(): Promise<NewsChatRequest> {
        return this._coreApiService.newsChatRequest;
    }

    getView(filter: IViewBody, callback: (entity: INewsMakerViewDTO[], totalCount: number) => void) {
        this.getDataRequest()
            .then(r => r.getView(filter, e => {
                if (e.respType === 'isCompleted') {
                    try {
                        callback(e.data.entities, e.data.totalCount)
                    } catch (e) {
                        console.error(e)
                    }
                }
                else
                    throw new Error(e?.message.title ?? 'ServiceDataProvider getView !isCompleted');
            },))
    }

    getById(idGlobal: string, callback: (data: INewsMakerDTO) => void) {
        this.getDataRequest()
            .then(r => r.getById(idGlobal, (e) => {
                if (e.respType === 'isCompleted') {
                    try {
                        callback(e.data)
                    } catch (e) {
                        console.error(e)
                    }
                }
                else
                    throw new Error(e?.message.title ?? 'ServiceDataProvider getView !isCompleted');
            },))
    }

    update(idGlobal: string, body: INewsMakerItemEditDTO, callback: (e) => void) {
        this.getDataRequest()
            .then(r => r.update(idGlobal, body, e => {
                if (e.respType === 'isCompleted') {
                    try {
                        callback(e)
                    } catch (e) {
                        console.error(e)
                    }
                }
                else
                    throw new Error(e?.message.title ?? 'NewsChatDataProvider update !isCompleted');
            },))
    }

    create(body: INewsMakerItemCreateDTO, callback: (e) => void) {
        this.getDataRequest()
            .then(r => r.create(body, e => {
                if (e.respType === 'isCompleted') {
                    try {
                        callback(e)
                    } catch (e) {
                        console.error(e)
                    }
                }
                else
                    throw new Error(e?.message.title ?? 'NewsChatDataProvider create !isCompleted');
            },))
    }

    deleteById(idGlobal: string, callback: () => void) {
        this.getDataRequest()
            .then((r) =>
                r.deleteById(idGlobal, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback();
                    } else {
                        throw new Error(e.message.title);
                    }
                })
            );
    }

    restore(idGlobal: string, callback: () => void) {
        this.getDataRequest()
            .then((r) =>
                r.restore(idGlobal, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback();
                    } else {
                        throw new Error(e.message.title);
                    }
                })
            );
    }

    upsert(body: INewsMakerItemCreateDTO, callback: (id: string) => void) {
        this.getDataRequest()
            .then(r => r.upsert(body, e => {
                if (e.respType === 'isCompleted') {
                    try {
                        callback(e.data)
                    } catch (e) {
                        console.error(e)
                    }
                }
                else
                    throw new Error(e?.message.title ?? 'NewsChatDataProvider upsert !isCompleted');
            },))
    }


    getActualNews(callback: (data: INewsChatViewDTO[]) => void) {
        this.getDataRequest()
            .then(r => r.getActualNews(e => {
                if (e.respType === 'isCompleted') {
                    try {
                        callback(e.data)
                    } catch (e) {
                        console.error(e)
                    }
                }
                else
                    throw new Error(e?.message.title ?? 'ServiceDataProvider getActualNews !isCompleted');
            },))
    }


    getNews(callback: (entity: INewsChatViewDTO[]) => void) {
        this.getDataRequest()
            .then(r => r.getNews(e => {
                if (e.respType === 'isCompleted') {
                    try {
                        callback(e.data)
                    } catch (e) {
                        console.error(e)
                    }
                }
                else
                    throw new Error(e?.message.title);
            },))
    }

    assignToAll(idGlobal: string, callback?: (data: any) => void) {
        this.getDataRequest()
            .then(r => r.assignToAll(idGlobal, (e) => {
                if (e.respType === 'isCompleted') {
                    callback?.(e);
                }
                else
                    throw new Error(e.message.title ?? 'NewsChatDataProvider assignToAll !isCompleted');
            })
            );
    }

    markNewAsViewed(idGlobal: string, callback?: (data: any) => void) {
        this.getDataRequest()
            .then(r => r.markNewAsViewed(idGlobal, (e) => {
                if (e.respType === 'isCompleted') {
                    callback?.(e);
                }
                else
                    throw new Error(e.message.title ?? 'NewsChatDataProvider markNewAsViewed !isCompleted');
            })
            );
    }
}